import { action, computed } from 'mobx'
import { ModalViewModel } from '@/infra/ModalViewModel'
import type { NavigateFn } from '@/RootStore'
import { links } from '@/utils/link'

/**
 * View model for the dialog shown when the user reaches their global
 * pickup limit.
 */
export class OverachieverDialogViewModel {
  /**
   * Whether the user has already seen the modal or not.
   */
  private _hasShown = false

  readonly modal = new ModalViewModel()

  constructor(
    private readonly _navigate: NavigateFn,
    private readonly _getGlobalJobCapacity: () => number,
  ) {}

  /**
   * How many open jobs the user may have across all workspaces.
   */
  @computed
  get globalJobCapacity() {
    return this._getGlobalJobCapacity()
  }

  /**
   * Shows the modal once.
   */
  @action.bound
  showOnce() {
    if (this._hasShown) {
      return
    }

    this._hasShown = true
    this.modal.show()
  }

  /**
   * Redirects to the jobs page.
   */
  @action.bound
  finishOpenJobs() {
    this._navigate(links.jobs(), { replace: true })
    this.modal.close()
  }
}
